import { AxiosInstance } from "axios";
import { Method, Resource } from "../Resource";

type Diff = {
  action?: string;
  path?: Array<string | number>;
  old?: string | null;
  new?: string | null;
};

export type AuditLog = {
  id: string;
  resourceId: string;
  resourceType: string;
  clientId: string;
  trigger: string;
  action: string;
  memberId: string | null;
  diff: Diff | null;
  createdAt: string;
};

export class AuditLogs extends Resource<AuditLog> {
  constructor(axiosInstance: AxiosInstance) {
    super("auditLogs", axiosInstance);
  }

  public async get(id: string): Promise<AuditLog> {
    return this.request({ method: Method.GET, path: id });
  }

  public async list({
    page,
    pageSize
  }: {
    page?: number;
    pageSize?: number;
  } = {}): Promise<AuditLog[]> {
    const { items: auditLogs } = await this.request({
      method: Method.GET,
      query: { page, pageSize }
    });

    return auditLogs;
  }
}
